import React from 'react';

const BGDocs = () => {
  return (
    <>

    <section className="section-bgdocs py-6 py-md-12">
        <div className="container">
          <div className="d-sm-flex align-items-center justify-content-center mb-6">
            
              <div className="icon-NextGenEU mx-auto mx-sm-7 mx-md-12 mb-7 mb-sm-0"></div>

              <div className="eu-plan mx-auto mx-sm-7 mx-md-12"></div>
           
          </div>

          <p className="text-center text-small mb-5">
            Открива се процедура "Избор с публична покана" по реда на ПМС № 80/09.05.2022 г. за определяне на изпълнител с предмет:
            "Доставка, монтаж, инсталиране и пускане в експлоатация на:
            - Обособена позиция 1: Система за съхранение с една кула (1 брой);
            - Обособена позиция 2: Хидравлична абкант преса (1 брой)".
           </p>

          <p className="text-center text-small mb-5">
            Документацията за провеждане на процедура „Избор с публична покана“ за определяне на изпълнител с предмет: 
            "Доставка, монтаж, инсталиране и пускане в експлоатация на:
            - Обособена позиция 1: Система за съхранение с една кула (1 брой);
            - Обособена позиция 2: Хидравлична абкант преса (1 брой)", 
            е във връзка с изпълнение на проект № BG-RRP-3.004-1079-C01 „Технологична модернизация в предприятието“ от 10.04.2023 г., който се изпълнява по процедура BG-RRP-3.004 „Технологична модернизация“ по Програмата за икономическа трансформация (ПИТ) към Националния план за възстановяване и устойчивост - с финансовата подкрепа на Механизма за възстановяване и устойчивост от Европейския съюз чрез инструмента NextGenerationEU.
            </p>

            <p className="text-center mb-5">
            <a
              className="text-center text-small text-danger"
              target="_blank"
              href="/Docs za izbor na izpulniteli_BG STEEL EOOD 2023.zip"
            >
              Документация за участие можете да изтеглите от тук.
            </a>
          </p>

          <p className="text-center text-small mb-5">
            “Тази публикация е създадена с финансовата подкрепа на Европейския съюз –
            NextGenerationEU. Цялата отговорност за съдържанието на документа се носи от
            „БГ СТИЙЛ“ ЕООД и при никакви обстоятелства не може да се приема, че
            тази публикация отразява официалното становище на Европейския съюз и СНД на ПИТ към МИР.“
            </p>

        </div>
      </section>
    
    
    
    <section className="section-bgdocs py-6 py-md-12">
        <div className="container">
          <div className="d-sm-flex align-items-center justify-content-center mb-6">
            
              <div className="icon-NextGenEU mx-auto mx-sm-7 mx-md-12 mb-7 mb-sm-0"></div>

              <div className="eu-plan mx-auto mx-sm-7 mx-md-12"></div>
           
          </div>

          <p className="text-center text-small mb-5">
            „БГ СТИЙЛ“ ЕООД е краен получател по проект № BG-RRP-3.004-1079-C01 „Технологична модернизация в предприятието“, който се изпълнява по процедура BG-RRP-3.004 „Технологична модернизация“ по Програмата за икономическа трансформация (ПИТ) към Националния план за възстановяване и устойчивост - с финансовата подкрепа на Механизма за възстановяване и устойчивост от Европейския съюз чрез инструмента NextGenerationEU.
          </p>

          <p className="text-center text-small mb-5">
            Общата стойност на проекта е 513 660.00	 лв., от които безвъзмездно финансиране: 256 830.00 лв. европейско финансиране чрез инструмента NextGenerationEU. Проектът е с обща продължителност 12 месеца, датата на стартиране на проекта е: 10.04.2023 г.
          </p>

          <p className="text-center text-small mb-5">
            В подкрепа на основната икономическа дейност под КИД 29.32, по проекта ще бъдат придобити: Система за съхранение с една кула (1 бр.) и Хидравлична абкант преса (1 бр.), които чрез цифровизация на процесите по управление на основната суровина за влагане в производството - листова ламарина и огъване на метални детайли, ще увеличат цялостния ефективен производствен капацитет.
          </p>
  
          <p className="text-center text-small mb-5">
            Целите на процедурата, относими към повишаване ефективността на производствените процеси, по-висока производителност, намаляване производствените разходи, оптимизация на производствената верига, създаване на условия за растеж и развитие на предприятието чрез цифровизация на производствените процеси с цел разширяване на капацитета, без нанасяне значителни вреди на околната среда, ще се постигнат посредством изпълнението на проекта. Инвестицията е напълно съобразена с изискванията на принципа за „ненанасяне на значителни вреди“ върху околната среда.
          </p>
  
          <p className="text-center text-small mb-5">
            “Тази публикация е създадена с финансовата подкрепа на Европейския съюз – NextGenerationEU. Цялата отговорност за съдържанието на документа се носи от „БГ СТИЙЛ“ ЕООД и при никакви обстоятелства не може да се приема, че тази публикация отразява официалното становище на Европейския съюз и СНД на ПИТ към МИР.“
          </p>
        </div>
      </section>
    
    
    <section className="section-bgdocs py-6 py-md-12">
        <div className="container">
          <div className="d-sm-flex align-items-center justify-content-center mb-6">
            <div className="icon-eu mx-auto mx-sm-7 mx-md-12 mb-7 mb-sm-0"></div>

            <div className="icon-innovations mx-auto mx-sm-7 mx-md-12"></div>
          </div>

          <p className="text-center text-small mb-5">
            „БГ СТИЙЛ“ ЕООД е бенефициент по проект № BG16RFOP002-6.002-0169-C01 „Възстановяване на МСП чрез подобряване на енергийната ефективност“, който се изпълнява по Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 с финансовата подкрепа на Европейския фонд за регионално развитие (ЕФРР) чрез Инструмента REACT-EU.
          </p>

          <p className="text-center text-small mb-5">
            Общата стойност на проекта е 268 658.00 лв., от които безвъзмездна финансова помощ (БФП) - 134 329.00 лв. европейско финансиране. Проектът е с обща продължителност 10 месеца, датата на стартиране на проекта е: 16.09.2022 г.
          </p>

          <p className="text-center text-small mb-5">
            Основната цел на проектите, изпълнявани в рамките на процедура № BG16RFOP002-6.002 „Възстановяване на МСП чрез подобряване на енергийната ефективност“, е: предоставяне на фокусирана подкрепа на българските малки и средни предприятия за възстановяване от икономическите последици от разпространението на пандемията COVID-19 чрез подобряване на енергийната им ефективност.
          </p>
        </div>
      </section>

    
      <section className="section-bgdocs py-6 py-md-12">
        <div className="container">
          <div className="d-sm-flex align-items-center justify-content-center mb-6">
            <div className="icon-eu mx-auto mx-sm-7 mx-md-12 mb-7 mb-sm-0"></div>

            <div className="icon-innovations mx-auto mx-sm-7 mx-md-12"></div>
          </div>

          <p className="text-center text-small mb-5">
            На 03.02.2020г. е сключен административен договор за предоставяне на
            безвъзмездна финансова помощ с № BG16RFOP002-2.040-0232-C01. БГ
            СТИЙЛ ЕООД е бенефициент по проект „Подобряване на производствения
            капацитет в БГ Стийл ЕООД ”, който се изпълнява с финансовата
            подкрепа на оперативна програма “Иновации и конкурентоспособност”
            2014-2020, съфинансирана от Европейския съюз чрез Европейски фонд за
            регионално развитие и от националния бюджет на Република България.
          </p>

          <p className="text-center text-small mb-5">
            Проектът е насочен към повишаване на производствения капацитет с цел
            повишаване конкурентоспособността и засилване на експортния
            потенциал на „БГ Стийл“ ЕООД чрез закупуване на следните ДМА,
            абсолютно необходими за изпълнение на включените в проекта дейности:
            щанцова машина, абкант машина, линия за прахово боядисване.
          </p>

          <p className="text-center text-small mb-5">
            Инвестицията ще добави нов капацитет в основни металообработващи
            операции: щанцоване, огъване, боядисване. Посредством закупените по
            проекта машини кандидатът ще извършва всички операции вътрешно в
            предприятието, чрез което ще съкрати сроковете за изпълнение, намали
            разходите и гарантира качеството.
          </p>
        </div>
      </section>

      <section className="section-bgdocs py-6 py-md-12">
        <div className="container">
          <div className="d-sm-flex align-items-center justify-content-center mb-6">
            <div className="icon-eu mx-auto mx-sm-7 mx-md-12 mb-7 mb-sm-0"></div>

            <div className="icon-innovations mx-auto mx-sm-7 mx-md-12"></div>
          </div>

          <p className="text-center text-small mb-5">
            Документация за провеждане на тръжна процедура по реда на ЗУСЕСИФ за
            определяне на изпълнител/и с предмет: <br /> „Закупуване и въвеждане
            в експлоатация на оборудване по следните обособени позиции: <br />{' '}
            Обособена позиция 1: Щанцова машина (1 брой); <br /> Обособена
            позиция 2: Абкант машина (1 брой); <br /> Обособена позиция 3: Линия
            за прахово боядисване (1 брой)“ <br />
          </p>

          <p className="text-center text-small mb-5">
            Документацията е във връзка с изпълнение на проект №
            BG16RFOP002-2.040-0232-C01 “Подобряване на производствения капацитет
            в БГ Стийл ЕООД”, процедура BG16RFOP002-2.040 „Подобряване на
            производствения капацитет в МСП“ по Оперативна програма „Иновации и
            конкурентоспособност“ 2014-2020.
          </p>

          <p className="text-center mb-5">
            <a
              className="text-center text-small text-danger"
              target="_blank"
              href="/bg-steel-BG16RFOP002-2.040-0232-C01.zip"
            >
              Свали файловете
            </a>
          </p>
        </div>
      </section>

      <section className="section-bgdocs py-6 py-md-12">
        <div className="container">
          <div className="d-sm-flex align-items-center justify-content-center mb-6">
            <div className="icon-eu mx-auto mx-sm-7 mx-md-12 mb-7 mb-sm-0"></div>

            <div className="icon-innovations mx-auto mx-sm-7 mx-md-12"></div>
          </div>

          <p className="text-center text-small mb-5">
            На основание Решение № 1/29.06.2020г. по чл. 9 от Постановление
            №160/01.07.2016 г. на Министерския съвет прекратявам процедура за
            избор на изпълнител по Обособена позиция 3: Линия за прахово
            боядисване (1 брой) с предмет определяне на изпълнители „Избор с
            публична покана“ за избор на изпълнител:
          </p>

          <p className="text-center text-small mb-5">
            “Закупуване и въвеждане в експлоатация на оборудване по следните
            обособени позиции: Обособена позиция 1: Щанцова машина (1 брой);
            Обособена позиция 2: Абкант машина (1 брой); Обособена позиция 3:
            Линия за прахово боядисване (1 брой)”
          </p>

          <p className="text-center mb-5">
            <a
              className="text-center text-small text-danger"
              target="_blank"
              href="/bg-steel-160-01.07.2016.pdf"
            >
              Виж файла
            </a>
          </p>
        </div>
      </section>

      <section className="section-bgdocs py-6 py-md-12">
        <div className="container">
          <div className="d-sm-flex align-items-center justify-content-center mb-6">
            <div className="icon-eu mx-auto mx-sm-7 mx-md-12 mb-7 mb-sm-0"></div>

            <div className="icon-innovations mx-auto mx-sm-7 mx-md-12"></div>
          </div>

          <p className="text-center text-small mb-5">
            „БГ СТИЙЛ“ ЕООД е бенефициент по проект № BG16RFOP002-2.089-0759-C01 „Подкрепа за малки предприятия с оборот над 500 000 лв. за преодоляване на икономическите последствия от пандемията COVID-19“, който се изпълнява с финансовата подкрепа на Оперативна програма “Иновации и конкурентоспособност” 2014-2020, съфинансирана от Европейския съюз чрез Европейски фонд за регионално развитие и от националния бюджет на Република България.
          </p>

          <p className="text-center text-small mb-5">
            Общата стойност на проекта е 50 000.00 лв., от които 50 000.00 лв. европейско финансиране. Проектът е с обща продължителност 3 месеца – датата на стартиране на проекта е: 11.10.2021 г.
          </p>

          <p className="text-center text-small mb-5">
            Проектът е насочен към подкрепа за преодоляване на икономическите последствия от пандемията COVID-19. Основната цел е осигуряването на оперативен капитал за българските малки предприятия, реализирали оборот над 500 000 лв. за 2019 г., за справяне с последиците от пандемията COVID-19.
          </p>

        </div>
      </section>

      <section className="section-bgdocs py-6 py-md-12">
        <div className="container">
          <div className="d-sm-flex align-items-center justify-content-center mb-6">
            <div className="icon-eu mx-auto mx-sm-7 mx-md-12 mb-7 mb-sm-0"></div>

            <div className="icon-innovations mx-auto mx-sm-7 mx-md-12"></div>
          </div>

          <p className="text-center text-small mb-5">
            Документация за провеждане на тръжна процедура по реда на ЗУСЕСИФ за
            определяне на изпълнител/и с предмет: <br /> „Закупуване и въвеждане
            в експлоатация на оборудване по следната обособена позиция: <br />{' '}
            Обособена позиция 3: Линия за прахово боядисване (1 брой)“
          </p>

          <p className="text-center text-small mb-5">
            Документацията е във връзка с изпълнение на проект №
            BG16RFOP002-2.040-0232-C01 “Подобряване на производствения капацитет
            в БГ Стийл ЕООД”, процедура <br /> BG16RFOP002-2.040 „Подобряване на
            производствения капацитет в МСП“ по Оперативна програма „Иновации и
            конкурентоспособност“ 2014-2020.
          </p>

          <p className="text-center">
            <a
              className="text-center text-small text-danger"
              href="/Dokumentacia_za_izbor_na_izpylnitel_BG_STEEL.zip"
            >
              Документация за избор на изпълнител BG STEEL
            </a>
          </p>
        </div>
      </section>
    </>
  );
};

export default BGDocs;
